import css from "./service.module.scss";
import { Layout } from "../../componentsV1/layout";
import { Pill } from "../../componentsV1/Pill";
import { Card } from "../../componentsV1/Card";
import Logo from "../../assets/v1/logo.png";
import { Antibody, Stack, Graph, Target, Validation } from "../../assets/v1/icons";

export const Service = () => {

  const steps = ["WB", "Widefield", "WF-SIM", "Confocal", "Airyscan", "SIM", "SIM²", "STORM"];


  const services = [
    {
      heading: "Rapid Validation",
      description: "Western blot validation, widefield/confocal imaging, and initial localization assessment for quick confidence in target performance.",
      otherText: "Typical timeline: 3–7 days",
      price: "$3K – $8K"
    },
    {
      heading: "Stepdown Analysis",
      description: "Full workflow from WB through SIM, with ROI analysis, structured interpretation, and resolution-aware biological conclusions.",
      otherText: "Typical timeline: 1–3 weeks",
      price: "$10K – $25K"
    },
    {
      heading: "Nanoscale Programs",
      description: "Full stepdown plus STORM, multiplex integration, and high-confidence nanoscale analysis for mechanistic or publication-grade studies.",
      otherText: "Typical timeline: 2–4+ weeks",
      price: "$25K+"
    }
  ]

  const logos = [
    {
      icon: Target,
      text: "Scientific Expertise"
    },
    {
      icon: Validation,
      text: "Rigorous Validation"
    },
    {
      icon: Stack,
      text: "Advanced Technology"
    },
    {
      icon: Graph,
      text: "Actionable Insights"
    }
  ]

  return (
    <Layout>
      <div className={css.heroContainer}>
        <div className={css.heroContent}>
            <img src={Logo} alt="logo" className={css.heroLogo} />
            <div className={css.heroText}>
            <h1>SERVICES <span>MARKETPLACE</span></h1>
            <div className={css.line} />
            <p>Expert analysis, validation, and custom scientific solutions.</p>
            </div>
             <div className={css.logoContainer}>
              {logos.map((item) => {
              return (
              <div className={css.logo}>
                <img src={item.icon} alt={item.text} />
                <p>{item.text}</p>
              </div>
              )})
              }
          </div>
        </div>
      </div>
      <div className={css.container}>
        <div className={css.section}>
          <section className={css.sectionBg}>
            <div className={css.subHeading}>WHAT WE DO</div>
            <h2 className={css.heading}>We don’t just generate images. We define what they mean.</h2>
            <p>Identifyn provides end-to-end protein validation services using a multi-resolution workflow that separates localization from true structure and delivers clear, defensible biological answers.</p>
          </section>
        </div>
        <section className={css.section}>
          <div className={css.cardContainer}>
            {services.map((service, index) => (
              <Card key={index} heading={service.heading} description={service.description} otherText={service.otherText} price={service.price} />
            ))
            }
          </div>
        </section>
        <section className={css.section}>
          <div className={css.sectionBg}>
            <div className={css.subHeading}>WHAT'S INCLUDED</div>
            <h2 className={css.heading}>One target. Fully resolved across modalities.</h2>
            <div className={css.pillsContainer}>
              {steps.map((app) => (
                <Pill key={app} text={app} />
              ))}
            </div>
            <p>Each modality answers a different question. We integrate the full workflow to distinguish what is present, what is localized, what is volumetrically real, and what begins to represent nanoscale truth.</p>
          </div>
        </section>
        <section className={`${css.section} ${css.columnSection}`}>
          <Card heading={'Who it’s for'} className={css.columnCard}>
            <ul className={css.list}>
              <li>Antibody developers</li>
              <li>Pharma and biotech teams</li>
              <li>Academic laboratories</li>
              <li>DDR, chromatin, and nuclear targets</li>
            </ul>
          </Card>
          <Card heading={'Deliverables'} className={css.columnCard}>
            <ul className={css.list}>
              <li>Multi-modal image sets</li>
              <li>Acquisition transparency</li>
              <li>Structured interpretation</li>
              <li>Resolution-aware biological conclusions</li>
              <li>Optional white paper or presentation-ready summary</li>
            </ul>
          </Card>
        </section>
        <section className={`${css.sectionBg} ${css.columnSection}`}>
          <div className={css.column}>
            <h2 className={css.heading}>Pricing philosophy</h2>
            <p>Projects are not priced per image or per assay. They are scoped by target complexity, required modalities, and depth of interpretation—so clients pay for answers, not just output.</p>
          </div>
          <div className={css.column}>
            <h2 className={css.heading}>How to start</h2>
            <p>Send the target, antibody, or biological question. We define the appropriate stepdown level, timeline, and cost—then deliver defensible data built for decision-making.</p>
          </div>
          <div className={css.btnsContainer}>
            <button className={css.btnLink}>Start a Project</button>
            <a href="tel:+19415290647" className={css.btnTransparent}>Call us Now</a>
          </div>
        </section>
        <section className={css.section}>
          <div className={`${css.sectionBg} ${css.sectionCentered}`}>
            <div className={css.subHeading}>FINAL OUTCOME</div>
            <h2 className={css.heading}>Start with a target. Leave with an answer.</h2>
            <p>Fast, precise, and resolution-aware validation built for research, publication, and high-confidence commercial decisions.</p>
          </div>
        </section>
      </div>
    </Layout>
  );
}


const StepCard = ({ number, title, question, insight, image }) => (
  <div className={`${css.sectionBg} ${css.stepCard}`}>
    <div className={css.infoContainer}>
      <div className={css.infoIcon}>{number}</div>
      <div className={css.infoHeading}>{title}</div>
      <div className={css.infoDescription}>{question}</div>
    </div>

    <div className={css.imagePanel}>
      {image ? (
        <img src={image} alt={title} className={css.image} />
      ) : (
        <div className={css.text}>Add image</div>
      )}
    </div>
    <Card heading={'Key insigt'} description={insight} className={css.insightCard} />
  </div>
);